module.exports = __webpack_public_path__ + "static/media/withgoodfriendsofNUS.a18dcfe3.jpeg";